export const isMobile = window.screen.width <= 425;
export const isTablet = window.screen.width <= 768;
